import React from 'react';
import { renderToString } from 'react-dom/server';

import { UserCircleIcon } from '../../../icon/regular';
import {
  BaseSaveInstructionData,
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import InlineInstruction from '../base-instruction/InlineInstruction';
import { addInstructionEvent, emitInstructionEvent } from '../utils';

class NameScriptInstruction extends InlineInstruction {
  protected static title = 'Name in script';

  get icon() {
    return renderToString(<UserCircleIcon style={{ height: 20 }} />);
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_WRAPPER,
      content: InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_CONTENT,
      action: InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_ACTION,
    };
  }

  openModal(instructionId: string): void {
    this.initEvents();
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_NAME_SCRIPT_INSTRUCTION_MODAL,
      { instructionId, isInline: true },
    );
  }

  getTooltip(tooltip: string): string {
    return `${InstructionActionTooltip.nameScript}: ${tooltip}`;
  }

  initEvents() {
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_NAME_SCRIPT_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SET_NAME_SCRIPT_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  removeEvents() {
    this.api.events.off(
      InstructionEvent.SAVE_NAME_SCRIPT_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    this.api.events.off(
      InstructionEvent.SET_NAME_SCRIPT_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  saveInstruction(data: BaseSaveInstructionData) {
    if (!this.isActive) {
      this.wrap(data);
    }
    this.removeEvents();
  }

  cancel() {
    this.setSelection();
    this.removeEvents();
  }
}

export default NameScriptInstruction;
